type Stat = {
  label: string
  value: number | string
}

type StatRowProps = {
  stats: Stat[]
}

export function StatRow({ stats }: StatRowProps) {
  return (
    <div className="flex items-center gap-6 py-3 border-b border-border/40">
      {stats.map((stat) => (
        <div key={stat.label} className="flex items-baseline gap-2">
          <span className="text-2xl font-semibold tracking-tight">{stat.value}</span>
          <span className="text-[13px] text-muted-foreground">{stat.label}</span>
        </div>
      ))}
    </div>
  )
}
